import * as pdfjsLib from "pdfjs-dist";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
import { uploadToS3WithPresignedURL } from "../network/apis/upload";
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

const readPdfLocally = async (file) => {
  const arrayBuffer = await file.arrayBuffer();

  const pdf = await pdfjsLib.getDocument({ data: arrayBuffer })
    .promise;

  return pdf.numPages;
};

export const uploadToS3 = async (type, file, fileName) => {
  const uniqueFileName = `${new Date().getTime()}_${fileName.replace(
    /\s/g,
    ""
  )}`;

  if (file) {
    switch (type) {
      case "pdf": {
        const { key } = await uploadToS3WithPresignedURL(
          {
            file_name: uniqueFileName,
            content_type: file?.type
          },
          file
        );
        const numPages = await readPdfLocally(file);

        return {
          numPages,
          link: key
        };
      }
      case "private": {
        const { key } = await uploadToS3WithPresignedURL(
          {
            file_name: uniqueFileName,
            content_type: file?.type
          },
          file,
          false
        );
        return {
          link: key
        };
      }
      case "public": {
        const { key } = await uploadToS3WithPresignedURL(
          {
            file_name: uniqueFileName,
            content_type: file?.type
          },
          file,
          true
        );
        return {
          link: key
        };
      }
      default:
        return null;
    }
  }
};
